export default {
  devTitle: 'EMMA LEE',
  index: '主頁',
  info: '走進逸達',
  companyphilosophy: '企業理念',
  companyCulture: '企業文化',
  productService: '產品服務',
  freightReservation: '兩岸貨運預約',
  valueAdd: '增值服務',
  customerCenter: '客戶專區',
  reserve: '我要預約',
  checkList: '我要查單',
  freightInquiry: '運費查詢',
  commonProblem: '常見問題',

  // Main
  customerService: '客戶服務：400-333-339',

  // Index
  freightQuery: '貨運單號查詢',
  'placeholder-number': '請輸入快件單號',
  search: '開始查詢',
  waybillNumber: '運單號',
  departure: '出發地',
  destination: '目的地',
  pieces: '件數',
  status: '狀態',
  deliveryTime: '送達時間',
  recipient: '簽收人',
  date: '日期時間',
  detail: '詳細',

  // 置底用
  aaa: 'aaa'
}
